/* Cuisine Inspirante — cadeau automatique (chargé sur tout le site)
   Règles dans window.CI_GIFT_RULES (snippets/meta-tags.liquid) :
     [{ key: 'lot8', trigger: <variante déclencheuse>, gift: <variante offerte> }]
   - Variante déclencheuse dans le panier et pas de cadeau : ajoute 1 cadeau
     (ligne marquée _ci_gift, propriété masquée au client).
   - Plus de variante déclencheuse : retire le cadeau.
   - Cadeau en quantité > 1 : ramené à 1.
   - Si le client retire lui-même le cadeau, il n'est pas remis pendant la session.
   La gratuité vient de la remise automatique Shopify « Achetez X, obtenez Y » :
   ce script ne touche à aucun prix. */
(function () {
  if (window.__ciGiftGuard) return;
  window.__ciGiftGuard = true;
  var rules = window.CI_GIFT_RULES || [];
  if (!rules.length || !window.fetch) return;

  var nativeFetch = window.fetch.bind(window);
  var KEY = 'ci_gift_declined';
  var had = {};
  var busy = false, again = false, timer = null;

  function getDeclined() { try { return JSON.parse(sessionStorage.getItem(KEY) || '{}'); } catch (e) { return {}; } }
  function setDeclined(o) { try { sessionStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {} }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch(input, init);
    if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
      p.then(function (r) { if (r && r.ok !== false) schedule(); }).catch(function () {});
    }
    return p;
  };

  function schedule() { clearTimeout(timer); timer = setTimeout(check, 300); }

  function post(path, body) {
    return nativeFetch(path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function refresh() {
    if (/\/cart\/?$/.test(window.location.pathname)) { window.location.reload(); return; }
    // Panier de l'appli Vanga (upsell) : il ne voit pas les ajouts faits par ce script sans rafraîchissement.
    if (window.Vanga && typeof window.Vanga.refresh === 'function') { try { window.Vanga.refresh(); } catch (e) {} }
    var di = document.querySelector('cart-drawer-items');
    if (di && typeof di.onCartUpdate === 'function') { try { di.onCartUpdate(); } catch (e) {} }
    nativeFetch('/?section_id=cart-icon-bubble', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var el = document.getElementById('cart-icon-bubble');
        var src = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
        if (el && src) el.innerHTML = src.innerHTML;
      })
      .catch(function () {});
  }

  function check() {
    if (busy) { again = true; return; }
    busy = true;
    var changed = false;
    var declined = getDeclined();
    nativeFetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var chain = Promise.resolve();
        rules.forEach(function (rule) {
          var items = cart.items || [];
          var hasTrigger = items.some(function (it) { return it.variant_id === rule.trigger; });
          var gifts = items.filter(function (it) { return it.properties && it.properties._ci_gift === rule.key; });
          if (!hasTrigger) {
            delete declined[rule.key];
            gifts.forEach(function (g) {
              chain = chain.then(function () { changed = true; return post('/cart/change.js', { id: g.key, quantity: 0 }); });
            });
            had[rule.key] = false;
          } else if (!gifts.length) {
            if (had[rule.key]) declined[rule.key] = true;
            if (!declined[rule.key]) {
              chain = chain.then(function () {
                return post('/cart/add.js', { items: [{ id: rule.gift, quantity: 1, properties: { _ci_gift: rule.key } }] })
                  .then(function (res) { if (!res.status) { changed = true; had[rule.key] = true; } });
              });
            } else {
              had[rule.key] = false;
            }
          } else {
            had[rule.key] = true;
            var qty = gifts.reduce(function (a, g) { return a + g.quantity; }, 0);
            if (qty > 1) {
              chain = chain.then(function () { changed = true; return post('/cart/change.js', { id: gifts[0].key, quantity: 1 }); });
              gifts.slice(1).forEach(function (g) {
                chain = chain.then(function () { return post('/cart/change.js', { id: g.key, quantity: 0 }); });
              });
            }
          }
        });
        return chain;
      })
      .catch(function () {})
      .then(function () {
        setDeclined(declined);
        busy = false;
        if (changed) refresh();
        if (again) { again = false; schedule(); }
      });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', check);
  else check();
})();
